<template>
  <button class="button pa-park-clip-button" :disabled="isDisabled" :class="additionalClass" @click="handleClickButton">
    <PAParkClipIcon />
    <p>{{buttonText}}</p>
  </button>
</template>

<script>
import PAParkClipIcon from '@/components/Pages/Parks/Finder/Images/park_clip.svg?inlineN'

import {GetParkData, GetParkCharacterListData} from '@/graphql/queries/Park.graphql'

import {ClipPark} from '@/graphql/mutations/Park.graphql'

export default {
  props : {
    parkId  : {
      default: null
    },
  },

  components : {
    PAParkClipIcon
  },

  data(){
    return {
      buttonText      : '',

      buttonTextSet   : {
        'cliped'  : 'クリップ済み',
        'unclip'  : 'クリップする'
      },

      isCliped        : false,
      isLoading       : false,
      isDisabled      : false,

      additionalClass : {
        'pa-park-clip-button-disabled'  : false,
        'is-loading'                    : false
      }
    };
  },

  watch : {
    isDisabled : {
      handler(value){
        if(value){
          this.additionalClass['pa-park-clip-button-disabled'] = true;
        }else{
          this.additionalClass['pa-park-clip-button-disabled'] = false;
        }
      },
      immediate: true
    },
    isLoading : {
      handler(value){
        this.additionalClass['is-loading'] = value;
        this.isDisabled = value;
      },
      immediate: true
    },

    isCliped : {
      handler(value){
        if(value){
          this.buttonText = this.buttonTextSet['cliped'];
        }else{
          this.buttonText = this.buttonTextSet['unclip'];
        }

        this.isDisabled = value;
      },
      immediate: true
    },

    park : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data !== null){
          this.isCliped = data.is_clipped;
        }
      },
      immediate: true,
      deep:true
    }
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    parkCharacterList : {
      query : GetParkCharacterListData,

      variables(){
        return {
          park_id : this.parkId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  methods : {
    async handleClickButton(){
      if(this.isDisabled === true) return;

      this.isLoading = true;

      await this.UXWaiting(500);

      const resultValue = await this.executeCLipPark();

      this.isLoading = false;

      this.$nextTick(() => {
        this.isDisabled = resultValue;
      });

      this.$apollo.queries.parkCharacterList.refetch();

      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;ひろばをクリップしました。',
        status      : 'primary',
        hasControl  : true,
        autoClose   : 5000
      }, {root:true});
    },

    executeCLipPark(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : ClipPark,
          variables : {
            parkId      : this.parkId
          },
          update    : (store, {data:{ClipPark:{park}}}) => {
            store.writeQuery({
              query     : GetParkData,
              variables : {
                id  : this.parkId
              },
              data      : {
                park : park
              }
            });
          }
        }).then(async ({data: {ClipPark:{result, park}}}) => {
          // Then finish clip park, clear founded park list
          this.$store.dispatch({
            type        : 'parkList/updateRemoveParkInList',
            listType    : 'public',
            parkId      : park.id
          });

          resolve(result);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}
</script>

<style lang="scss">
.pa-park-clip-button{
  box-sizing: border-box;
  border:0;
  margin:0;
  padding:0;
  width:100%;
  padding:.3rem;
  background-color:#BB8C62;
  background-color:#b46923;
  background-color:#b16f31;
  border-radius: 8px;
  color:#E3CFBD;
  color:#d3bca9;
  display: flex;
  justify-content:center;

  > svg{
    margin-top:2px;
    margin-right:.15rem;
    width:12px;

    path{
      stroke: #E3CFBD;
    }
  }

  &-disabled{
    background-color:#AC815A;
    color:#B59E89;

    > svg{
      path{
        stroke:#B59E89;
      }
    }
  }

  &.is-loading{
    svg{
      display: none;
    }
  }

  &:hover, &:active{
    color:#d3bca9;
  }

  &:focus{
    box-shadow:none;
  }

  &[disabled]{
    background-color:#AC815A;
    color:#B59E89;
    opacity: 1;
    > svg{
      path{
        stroke:#B59E89;
      }
    }
  }

  &.is-loading::after{
    border: 1.3px solid #E3CFBD;
    border-right-color: transparent;
    border-top-color: transparent;
  }
}
</style>